import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants';

interface AdminGuardProps {
  children: React.ReactNode;
}

/**
 * Route guard to protect admin-only routes
 * Redirects to dashboard if user is not an admin
 * Note: Auth initialization is done in App.tsx, this guard just checks the state
 */
export const AdminGuard = ({ children }: AdminGuardProps) => {
  const { isAuthenticated, isLoading, user, isAdmin } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Redirect to regular dashboard if not an admin
  if (!isAdmin()) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};